var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.requiredDocuments.length > 0
        ? _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.requiredDocuments, function(requiredDocument, i) {
        return _c("required-document", {
          key: i,
          attrs: {
            "required-document": requiredDocument,
            index: i,
            disabled: _vm.disabled,
            "qualification-levels": _vm.qualificationLevels
          },
          on: {
            remove: function() {
              return _vm.removeRequiredDocument(i)
            }
          }
        })
      }),
      _vm._v(" "),
      !_vm.disabled
        ? _c(
            "div",
            {
              staticClass: "add-button",
              on: { click: _vm.addRequiredDocument }
            },
            [_c("i", { staticClass: "fas fa-plus-circle" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.requiredDocuments.length === 0
        ? _c("input", {
            attrs: { name: "required_documents", value: "", type: "hidden" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-5" }, [
      _c("label", [_vm._v("Type:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-7" }, [
      _c("label", [_vm._v("Title:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c2c2985", { render: render, staticRenderFns: staticRenderFns })
  }
}